import { isElement, isText } from './dom/node';
import { createIterable } from './iterable';

export interface DecorationNodeResult {
  node: Node;
  index: number;
  length: number;
}

export const DECORATION_ATTRIBUTE_NAME = 'data-editor-decoration';

export function isDecorationNode(node: Node): boolean {
  return isElement(node) && node.hasAttribute(DECORATION_ATTRIBUTE_NAME);
}

export function getDecorationNodes(container: Node): Iterable<DecorationNodeResult> {
  const document = container.ownerDocument;
  if (!document) {
    return [];
  }

  return createIterable(function* createDecorationIterator() {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
      acceptNode: candidateNode =>
        isText(candidateNode) || isDecorationNode(candidateNode)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP,
    });

    let index = 0;
    let node: Node | null;
    while ((node = walker.nextNode())) {
      if (isDecorationNode(node)) {
        yield {
          node,
          index,
          length: (node.textContent || '').length,
        };
      } else if (isText(node)) {
        index += node.data.length;
      }
    }
  });
}
